
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.556.25C1.398.25.25 1.081.25 2.333v9.334c0 1.252 1.148 2.083 2.306 2.083h10.888c1.158 0 2.306-.832 2.306-2.083V2.333c0-1.252-1.148-2.083-2.306-2.083H2.556zM1.75 2.333c0-.214.252-.583.806-.583h10.888c.554 0 .806.369.806.583v9.334c0 .215-.252.583-.806.583H2.556c-.554 0-.806-.368-.806-.583V2.333zM11 7l-5 3V4l5 3z","fill":"#C4C4C4"}})])
          )
        }
      }
    